import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface ProofOfEarningsSuccessBottomSheetProps {
  modalState: UseModalState;
  workerEmail: string;
}

export function ProofOfEarningsSuccessBottomSheet(props: ProofOfEarningsSuccessBottomSheetProps) {
  const { modalState, workerEmail } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth onClick={modalState.closeModal}>
            Done
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="request-sent"
        title="Proof of earnings sent"
        description={`We sent your proof of earnings to ${workerEmail}.`}
      />
    </BottomSheet>
  );
}
